const characters = 'abcdefghijklmnopqrstuvwxyz';
function random_string(length = 10) {
   let result = '';
   const charactersLength = characters.length;
   for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
   }
   return result;
}

function is_array_valid<T>(input: any[] | null | undefined | T): input is any[] {
   if (!input || !Array.isArray(input) || !input.length || !input?.[0]) return false;
   return true;
}

type AnyObject = { [key: string]: any };
function deep_merge<T extends AnyObject = AnyObject, U extends AnyObject = AnyObject>(
   source: T,
   target: U
): T & U {
   // @ts-ignore
   return (
      // @ts-ignore
      void Object.keys(target).forEach((key) => {
         source[key] instanceof Object && target[key] instanceof Object
            ? source[key] instanceof Array && target[key] instanceof Array
               // @ts-ignore
               ? void (source[key] = Array.from(new Set(source[key].concat(target[key]))))
               : !(source[key] instanceof Array) && !(target[key] instanceof Array)
                  ? void deep_merge(source[key], target[key])
                  // @ts-ignore
                  : void (source[key] = target[key])
            // @ts-ignore
            : void (source[key] = target[key]);
      }) || source
   );
}
type UpdateOrAppendRuneUsingID<T> = { rune: { value: any }; object: T };

function update_array_or_append_rune_using_id<T>({
   rune,
   object
}: UpdateOrAppendRuneUsingID<T>): void {
   const rune_length = rune.value.length;
   type TID = T & { id: string };

   for (let i = 0; i < rune_length; i++) {
      if ((rune.value[i] as TID)?.id === (object as TID)?.id) {
         rune.value[i] = object;
         return;
      }
   }
   // console.log('NOT FOUND... PUSHING');
   rune.value.push(object);
}

function clean_object<T>(obj: T): Partial<T> {
   const cleaned_obj: Partial<T> = {};
   for (const key in obj) {
      if (obj[key] !== undefined) {
         cleaned_obj[key] = obj[key];
      }
   }
   return cleaned_obj as any;
}

function latest_date_in_array<T, K extends keyof T>(array: T[] | null, key: K) {
   try {
      if (!array?.length) return new Date(0)

      const latest_timestamp = array.reduce((latest, item) => {
         const item_timestamp = Date.parse(item[key] as string); // Direct timestamp parsing
         return item_timestamp > latest ? item_timestamp : latest;
      }, 0); // Initialize with a very old timestamp
      // console.log({ latest_timestamp })
      const latest_date = latest_timestamp > 0 ? new Date(latest_timestamp) : new Date(0); // Convert back to Date object if needed

      return latest_date;
   } catch (error) {
      return new Date(0);
   }
}

function latest_date_string_in_array<T, K extends keyof T>(array: T[] | null, key: K) {
   try {
      if (!array?.length) return new Date(0).toISOString();

      const latest_timestamp = array.reduce((latest, item) => {
         const item_timestamp = Date.parse(item[key] as string); // Direct timestamp parsing
         return item_timestamp > latest.number ? { string: item[key] as string, number: item_timestamp } : latest;
      }, { string: '', number: 0 });

      const latest_date = latest_timestamp.number > 0 ? latest_timestamp.string : new Date(0).toISOString(); // Convert back to Date object if needed

      return latest_date;
   } catch (error) {
      return new Date(0).toISOString();
   }
}

export const graph_utils = {
   latest_date_in_array,
   random_string,
   is_array_valid,
   latest_date_string_in_array,
   deep_merge,
   update_array_or_append_rune_using_id,
   clean_object
};
